import { render, staticRenderFns } from "./CongelarProjecao.vue?vue&type=template&id=21c4b287"
import script from "./CongelarProjecao.vue?vue&type=script&lang=js"
export * from "./CongelarProjecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports